import { render, staticRenderFns } from "./pandaServiceFeatures.vue?vue&type=template&id=b33fe03e&scoped=true"
import script from "./pandaServiceFeatures.vue?vue&type=script&lang=js"
export * from "./pandaServiceFeatures.vue?vue&type=script&lang=js"
import style0 from "./pandaServiceFeatures.vue?vue&type=style&index=0&id=b33fe03e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33fe03e",
  null
  
)

export default component.exports